import axios from "axios";
import authHeader from "./auth-header";
import apihostname from "./apihostname";

const instance = axios.create({
  baseURL: apihostname,
  headers: authHeader(),
});

class ExternalService {
  getDeed(body) {
    return instance.post("/getdeed", body);
  }
  getPersonal(body) {
    return instance.post("/personalsimple", body);
  }
}

export default new ExternalService();
